module.exports = __webpack_public_path__ + "img/zf-logo-white-cirle.b7b56a4a.png";